/*eslint-disable*/

export const addedDictKeys = '';
import { urlRegNoRequireHttps, idNumber, phoneReg, email, ebcuZipCOde, telephoneReg, noSpaceReg } from '@/modules/mdm/utils/regList.js'
export const collapse = [
    {
        title: '基本信息',
        ref: 'biddingForm',
        formName: 'biddingInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户名称',
                prop: 'customerName',
                mustFill: true,
                type: 'advance',
                name: '请输入客户名称或编码查询',
                value: 'customerName',
                width: 200,
                // advanceConfig配置搜索条件，tableConfig配置弹窗中的表格列信息
                advanceConfig: [
                    { prop: 'customerName', value: '客户名称' },
                    { prop: 'customerCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'customerCode', value: '客户编码' },
                    { prop: 'customerName', value: '客户名称' },
                    { prop: 'customerGroupName', value: '客户系名称' },
                    { prop: 'customerOwnerName', value: '客户经理' },
                    { prop: 'calCustomerLevelCode', value: '细分等级', type: 'select', optionsKey: 'NEOCRM_CUSTOMER_LEVEL' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: '/customer/info/page',
                method: 'post',
                cbParams: ['customerCode', 'customerName#customerName', 'customerChannel', 'customerGroupCode', 'customerGroupName',
                    'customerLevelCode#customerLevel', 'customerOwnerName', 'customerOwnerCode'],
                // eslint-disable-next-line complexity
                beforeRequest: (params) => {
                    params.customerStatus = '1';
                    const inputKey = (params.customerName ? params.customerName : (params.customerCode ? params.customerCode : '')).trim();
                    // 检查inputKey是否符合使用name的条件
                    const hasChinese = /[\u4e00-\u9fa5]/.test(inputKey);
                    const englishCount = (inputKey.match(/[a-zA-Z]/g) || []).length;
                    const hasSymbol = /[^\w\s]/.test(inputKey);
                    // 规则: 如果inputKey包含中文、英文长度大于1、或存在符号，则使用name
                    if (hasChinese || englishCount > 1 || hasSymbol) {
                        params.customerName = inputKey;
                        params.customerCode = null;
                    } else {
                        params.customerName = null;
                        params.customerCode = inputKey;
                    }

                    return params;
                },
                sort: true,
                rule: [
                    { required: false, message: '客户名称不能为空', trigger: 'blur' },
                ]
                // advanceCode: 'advanceCode'
            },
            {
                label: '客户系名称',
                prop: 'customerGroupName',
                width: 150,
            },
            {
                label: '客户等级',
                prop: 'customerLevel',
                value: 'customerLevel',
                type: 'custom',
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
                visible: true
            },
            {
                label: '客户经理/开发人',
                prop: 'customerOwnerName',
                value: 'customerOwnerName',
                type: 'custom',
                visible: true
            },
            {
                label: '投标网站名称',
                prop: 'websiteName',
                value: 'websiteName',
                maxlength: 200,
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '投标网站名称不能为空', trigger: 'blur' },
                ]
            },
            {
                label: '投标网址',
                prop: 'websiteUrl',
                value: 'websiteUrl',
                type: 'custom',
                visible: true,
                span: 24,
                rule: [
                    {
                        pattern: urlRegNoRequireHttps,
                        message: '投标网址格式不对，支持www或https://开头',
                        trigger: 'blur'
                    },
                    { required: false, message: '投标网址不能为空', trigger: 'blur' },
                ]
            },
            {
                label: '投标账号类型',
                prop: 'accountType',
                value: 'accountType',
                type: 'custom',
                optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_TYPE',
                visible: true
            },
            {
                label: '账号',
                prop: 'websiteAccount',
                value: 'websiteAccount',
                type: 'custom',
                maxlength: 50,
                visible: true,
                rule: [
                    { required: true, message: '账号不能为空', trigger: 'blur' },
                ]
            },
            {
                label: '密码',
                prop: 'accountPassword',
                value: 'accountPassword',
                type: 'custom',
                maxlength: 50,
                visible: true,
                rule: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ]
            },
            {
                label: '账号状态',
                prop: 'accountStatus',
                value: 'accountStatus',
                type: 'custom',
                optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_STATUS',
                visible: true
            },
            {
                label: '绑定手机号',
                prop: 'registrantPhone',
                value: 'registrantPhone',
                type: 'custom',
                rule: [
                    {
                        pattern: phoneReg,
                        message: '手机号格式不对',
                        trigger: 'blur'
                    },
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                ],
                visible: true
            },
            {
                label: '账号绑定人',
                prop: 'accountRegistrant',
                value: 'accountRegistrant',
                type: 'custom',
                visible: true
            },
            {
                label: '账号绑定人名称',
                prop: 'accountRegistrantName',
                value: 'accountRegistrantName',
                type: 'custom',
                visible: true
            },
            {
                label: '账号所有人',
                name: '账号所有人',
                prop: 'accountManager',
                value: 'accountManager',
                type: 'advance',
                // maxNum: 10, // 多选条数限制
                isFixed: false,
                advanceConfig: [
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名' }
                ],
                tableConfig: [
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    // { 'prop': 'esusPositionName', 'value': '职位' }, // 新接口没有这个字段
                    { 'prop': 'escoCompanyNameCn', 'value': '部门' }
                ],
                prefix: '/api-lcrm',
                advanceUrl: `/crmUser/page`,
                cbParams: ['esusLoginName#accountManager', 'esusUserNameCn#accountManagerName'],
                beforeRequest: (params) => {
                    const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                    if (reg.test(inputKey)) {
                        params.esusUserNameCn = inputKey;
                        params.esusLoginName = null;
                    } else {
                        params.esusLoginName = inputKey;
                        params.esusUserNameCn = null;
                    }
                    return params;
                },
                rule: [
                    { required: true, message: '账号管理人不能为空', trigger: 'blur' },
                ],
            },
            {
                label: '账号所有人名称',
                prop: 'accountManagerName',
                value: 'accountManagerName',
                type: 'custom',
                visible: true
            },
            {
                label: '账号所有人状态',
                prop: 'accountManagerStatus',
                value: 'accountManagerStatus',
                type: 'custom',
                visible: true
            },
            {
                label: '备注',
                prop: 'remark',
                value: 'remark',
                type: 'input',
                sourceType: 'input',
                inputType: 'textarea',
                maxlength: 500,
                showWordLimit: true,
                rows: 4,
                span: 24,
                visible: true
            }
        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '90天内是否有更新',
                prop: 'hasUpdateIn90days',
                value: 'hasUpdateIn90days',
                optionsKey: 'YES_OR_NO',
                type: 'custom',
                visible: true
            },
            {
                label: '是否已复核',
                prop: 'isReviewed',
                value: 'isReviewed',
                optionsKey: 'YES_OR_NO',
                type: 'custom',
                visible: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom',
                visible: true
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom',
                visible: true
            },
            {
                label: '账号所有人更新时间',
                prop: 'managerUpdateTime',
                value: 'managerUpdateTime',
                type: 'custom',
                visible: true
            },
            {
                label: '密码更新时间',
                prop: 'passwordUpdateTime',
                value: 'passwordUpdateTime',
                type: 'custom',
                visible: true
            }
        ]
    },

    {
        title: '变更日志',
        ref: 'changeLogForm',
        formName: 'changeLogInfo',
        col: 1,
        labelWidth: '100px',
        visible: true,
        collapseSlot: 'collapse-other-append',
        visible: true,
        formList: []
    }
];
